import { Component, Pipe, PipeTransform, AfterViewInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser'


@Component({
    moduleId: module.id,
    selector: 'cse-body',
    templateUrl: './cse.body.html'
})

export class Body implements AfterViewInit {
    title = 'app';

    ngAfterViewInit() {
        document.getElementById("loaderInit").remove();
    }

}



@Pipe({
    name: 'dateFormat'
})
export class DateFormatPipe extends DatePipe implements PipeTransform {
    transform(date: any, args?: any): any {
        if (date) {
            var fecha = date.split(" ")[0];
            var hour = date.split(" ")[1];
            if (hour != undefined) {
                return fecha.split("-")[2] + "/" + fecha.split("-")[1] + "/" + fecha.split("-")[0] + " " + hour.split(":")[0] + ":" + hour.split(":")[1];
            } else {
                return fecha.split("-")[2] + "/" + fecha.split("-")[1] + "/" + fecha.split("-")[0];
            }
        } else {
            return date;
        }
    }
}

@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
    constructor(private sanitized: DomSanitizer) { }
    transform(value) {
        if (value && value.length > 0) {
            return this.sanitized.bypassSecurityTrustHtml(value);
        } else {
            return value;
        }
    }
}


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/cse.body.ts